<div class="flex items-center justify-center min-h-screen bg-gray-100">
  <form (ngSubmit)="login()" class="bg-white p-8 rounded shadow-md w-96 space-y-4">
    <h2 class="text-2xl font-bold mb-4 text-center">Login</h2>
    <input [(ngModel)]="email" name="email" type="email" autocomplete="username" placeholder="Email" class="w-full p-2 border rounded" required />
    <input [(ngModel)]="password" name="password" type="password" autocomplete="current-password" placeholder="Password" class="w-full p-2 border rounded" required />
    <label class="flex items-center gap-2 text-sm text-gray-700 select-none">
      <input [(ngModel)]="stayLoggedIn" name="stayLoggedIn" type="checkbox" class="h-4 w-4 rounded" />
      Stay logged in on this computer
    </label>
    <button
      type="submit"
      [disabled]="isLoggingIn()"
      class="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {{ isLoggingIn() ? 'Logging in…' : 'Login' }}
    </button>
    @if (error(); as message) {
      <div class="text-red-500 text-center">{{ message }}</div>
    }
  </form>
</div>
